import { signInWithRedirect, signOut } from 'aws-amplify/auth';
import images from '../../assets/images';
import { useTranslation } from 'react-i18next';
import { Common } from '../../utils/constants';

interface SocialMediaLoginFormProps {
  migrationToken?: string;
  termsAndCondition?: { id: number; accepted: boolean };
  action?: string;
}

const SocialMediaLoginForm: React.FC<SocialMediaLoginFormProps> = ({ migrationToken, termsAndCondition, action }) => {
  const { t } = useTranslation();

  const thirdPartyLogin = async (provider) => {
    if (migrationToken) {
      sessionStorage.setItem(Common.FederatedAccountMigrationSessionKeys.MIGRATION_TOKEN, migrationToken);
    }
    localStorage.setItem('is_federate', 'true');
    if (termsAndCondition) {
      localStorage.setItem('terms_and_condition', JSON.stringify(termsAndCondition));
    }
    await signOut({ global: false }).catch(() => {});
    await signInWithRedirect({ provider });
  };

  return (
    <div className={`${migrationToken ? '' : 'pb-3'}`}>
      {!migrationToken && (
        <div>
          <hr className="mt-0" />
          <p className="text-center social-login-text">
            {action == 'signup' ? t('signup.socialMediaText') : t('login.socialMediaText')}
          </p>
        </div>
      )}
      <div className="social-media form-row justify-content-center d-flex">
        <div className="social-media-icon">
          <a
            href="#"
            title={t<string>('login.label.facebook')}
            onClick={() => thirdPartyLogin('Facebook')}
            className="d-flex align-items-center justify-content-center"
          >
            <img src={images.facebookBlackSVG} alt="mr-0" />
          </a>
        </div>
        <div className="social-media-icon">
          <a
            href="#"
            title={t<string>('login.label.apple')}
            onClick={() => thirdPartyLogin('Apple')}
            className="d-flex align-items-center justify-content-center"
          >
            <img src={images.appleBlackSVG} alt="" />
          </a>
        </div>
        <div className="social-media-icon">
          <a
            href="#"
            title={t<string>('login.label.google')}
            onClick={() => thirdPartyLogin('Google')}
            className="d-flex align-items-center justify-content-center"
          >
            <img src={images.googleBlackSVG} alt="" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default SocialMediaLoginForm;
